export default {
  apiUrl: 'https://front10-platform-strapi.herokuapp.com'
};
